export default __webpack_public_path__ + "static/media/outgoing-danger.d7cb871b.svg";